/* Check Available Products in Wishlist and Update Wishlist IDs */
setInterval(updateWishlistIDS, 500);
function updateWishlistIDS() {
    let addAllButton = document.querySelector('#add-all-wishlist');
    let body = document.querySelector('body');
    let elements = document.querySelectorAll('.product-card[data-available="true"]');
    let ids = [];
    if( elements.length ){
        for (var i=0; i<elements.length; i++) {
            ids.push(elements[i].dataset.epi);
        }
        if( addAllButton ){
            addAllButton.dataset.wishlistIds = ids.join(',');
        }
        body.classList.remove('wishlist-add-all-unavailable');
        body.classList.add('wishlist-add-all-available');
    }else{
        if(addAllButton)
          addAllButton.dataset.wishlistIds = '';
        body.classList.remove('wishlist-add-all-available');
        body.classList.add('wishlist-add-all-unavailable');
    }
}

//Add all items from wishlist
document.addEventListener('click',function(e){
    if(e.target.id == 'add-all-wishlist'){
      console.log( addAllItems(e.target.dataset.wishlistIds) )
    }
});

function addAllItems(variantIdArray) {
    toggleLoader();
    //split fake liquid array to make proper array
    var newVariantIdArray = variantIdArray.split(',');

    //map over variant array to create an array of objects with quantity and id
    var product_data = newVariantIdArray.map(variantId => {
      return {quantity: 1, id: variantId}
    })

    //add the items to the data object we need to pass to the fetch call 
    var data = {
      items: product_data
    }
          
    fetch('/cart/add.js', {
      body: JSON.stringify(data),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With':'xmlhttprequest'
      },
      method: 'POST'
    }).then((response) => {
      removeItemsFromWishlist();
      return response.json();
    }).catch((err) => {
      toggleLoader();
      console.error(err)
    });
}

//Check Lists
function removeItemsFromWishlist(){
  window._swat.fetchLists({
    callbackFn: function(lists) {
      lists.forEach(list => { //Cycle through lists
        if(list.lname == 'Wishlist'){ //Find Wishlist
          removeProductsFromWishlist(list.lid, list.listcontents); //Pass list ID for removing products
        }
      });
    },
    errorFn: function(xhrObj) {
      toggleLoader();
    }
  });
}

//Use list ID to remove products related products from Wishlist
function removeProductsFromWishlist(lid, listcontents){
  var allAvailableWishlistItems = document.querySelector('#add-all-wishlist').dataset.wishlistIds.split(',');

  //Build an array of List Item Input based on available products.
  var listItemMaps = [];
  listcontents.forEach(item => {
    if( allAvailableWishlistItems.includes((item.epi).toString()) ){
      listItemMaps.push({
        epi: item.epi,
        empi: item.empi,
        du: item.du,
        qty: 1
      });
    }
  });

  //Remove products from Wishlist
  window._swat.removeProductsFromList(lid, listItemMaps, function(resp){
    window.location.href = '/cart'; //Navigate to 
  }, function(xhrObject) {
    toggleLoader();
    console.log(xhrObject)
  });
}